export default __webpack_public_path__ + "static/media/ecosystem-bags.97e84ec4.png";